// @ts-check
import React, { forwardRef } from "react"
import ClientChip from "../molecules/ClientChip.molecule"
import Dropdown from "../atoms/Dropdown.atom"
import { generateRandomId } from "../../utils/strings.utils"

/** @type {import('./DropdownClientPicker.compound.types').DropdownClientPicker} */
const ClientPicker = forwardRef(
  (
    {
      clients,
      id = `client-picker-${generateRandomId()}`,
      className,
      optionLabel = "name",
      optionValue = "code",
      selectedClient,
      setSelectedClient,
      ...dropdownProps
    },
    ref
  ) => {
    const itemTemplate = (option) => {
      return (
        <div className="flex gap-2 align-items-center">
          <ClientChip clientCode={option.code} />
          <span className="overflow-hidden white-space-nowrap text-overflow-ellipsis">
            {option.name}
          </span>
        </div>
      )
    }

    const valueTemplate = (option) => {
      if (option) {
        return (
          <div
            className="flex gap-2 align-items-center flex"
            style={{ marginTop: "-3px" }}
          >
            <ClientChip clientCode={option.code} />
            <span
              className="white-space-nowrap overflow-hidden text-overflow-ellipsis"
              title={option.name}
            >
              {option.name}
            </span>
          </div>
        )
      } else {
        return <span>Elige un cliente</span>
      }
    }
    return (
      <Dropdown
        ref={ref}
        inputId={id}
        value={selectedClient}
        options={clients}
        onChange={(e) => setSelectedClient(e.value)}
        panelClassName="max-w-23rem"
        optionLabel={optionLabel}
        optionValue={optionValue}
        scrollHeight="480px"
        placeholder="Elige un cliente"
        style={{ width: "fit-content", height: "40px" }}
        itemTemplate={itemTemplate}
        valueTemplate={valueTemplate}
        className={`w-15rem ${className}`}
        {...dropdownProps}
      />
    )
  }
)

export default ClientPicker
